import {
  expandViewport,
  isTMA,
  swipeBehavior,
  init as telegramSdkInit,
} from '@telegram-apps/sdk-react'
import { useEffect, useState } from 'react'
import { injectMockTelegramData, trpc } from '../utils'

interface TmaState {
  isLoaded: boolean
  isForbidden: boolean
}

export const useTelegramSdk = (): TmaState => {
  const createTempUser = trpc.user.createTempUser.useMutation()
  const [state, setState] = useState<TmaState>({
    isLoaded: false,
    isForbidden: false,
  })

  useEffect(() => {
    const init = async () => {
      if (await isTMA()) {
        telegramSdkInit()

        if (expandViewport.isAvailable()) {
          expandViewport()
        }
        if (swipeBehavior.disableVertical.isAvailable()) {
          swipeBehavior.disableVertical()
        }

        setState({ isLoaded: true, isForbidden: false })
        return
      }

      if (import.meta.env.MODE === 'development') {
        const fake = localStorage.getItem('fake_telegram_id')
        const id =
          fake ?? String((await createTempUser.mutateAsync()) as number)
        localStorage.setItem('fake_telegram_id', id)

        injectMockTelegramData(Number(id))

        setState({ isLoaded: true, isForbidden: false })
        return
      }

      setState({ isLoaded: false, isForbidden: true })
    }

    void init().catch(console.error)
  }, [])

  return state
}
